import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-516457c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray" }
const _hoisted_2 = {
  key: 1,
  class: "container d-flex justify-content-between py-lg-5 py-3 p-0"
}
const _hoisted_3 = { class: "row w-100 m-0 p-0 gx-3 gx-lg-5" }
const _hoisted_4 = { class: "col-lg-3" }
const _hoisted_5 = { class: "col-lg-9" }

import HeaderDefault from '@/components/header/default/index.vue'
import Footer from '@/components/footer-employee/index.vue'
import Aside from '../aside/index.vue'
import InviteModal from '@/views/shared/communities/components/InviteModal.vue'
import InviteModalError from '@/views/shared/communities/components/InviteModalError.vue'
import { useRoute, useRouter } from 'vue-router'
import InquiryForm from '@/views/user/users/inquiry/form-inquiry/index.vue'
import Membership from '@/components/membership/index.vue'
import communityAdminTermService from '@/services/community-admin-term.service'
import { computed, ComputedRef, onMounted, ref, watch } from 'vue'
import communityServices from '@/services/communities.service'
import { useStore } from 'vuex'
import { CommunityStateTypes } from '@/store/modules/community'
import { COMMUNITY_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const dataMembership = ref({})
const store = useStore()
const router = useRouter()
const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const checkRouteNotAuth =
  route.path.includes('users/login') ||
  route.path.includes('alumni/login') ||
  route.path.includes(`/${route.path.split('/')[1]}/2fa_notification`) ||
  route.path.includes(`/${route.path.split('/')[1]}/input_authentication_code`) ||
  route.path.includes(`/${route.path.split('/')[1]}/join_users`) ||
  route.path.includes(`/${route.path.split('/')[1]}/invited_communities/employee`) ||
  route.path.includes(`/${route.path.split('/')[1]}/account/profile/edit`)
onMounted(async () => {
  checkDaikoLogin()
})

watch(
  () => route.path,
  () => {
    checkDaikoLogin()
  }
)

const checkDaikoLogin = async () => {
  try {
    const routerCurrent = router.currentRoute.value.path.split('/')

    if (routerCurrent.includes('dashboard')) {
      return
    }
    if (routerCurrent[1] === 'community' && routerCurrent[2] === 'communities') {
      const communityRes = await communityServices.getCommunity()
      await store.dispatch(COMMUNITY_STORE.ACTIONS.GET_ALL_COMMUNITIES, communityRes?.data)
      const isDaiKo = communityRes.data.data.filter((item: any) => item.id === me.value?.community_id)[0]?.is_daiko
      if (isDaiKo) router.push(`/${router.currentRoute.value.path.split('/')[1]}/lobby`)
    }
  } catch (error) {
    console.log(error)
  }
}

const ShowMembership = async (): void => {
  try {
    const response = await communityAdminTermService.getMembershipApi(route.params?.id, 'employee')
    if (response?.status === 200) dataMembership.value = response?.data?.data
  } catch (error) {
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderDefault, { ShowMembership: ShowMembership }),
    _createElementVNode("section", _hoisted_1, [
      (_unref(route).meta?.hideSidebar)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Aside),
                _createVNode(InviteModal),
                _createVNode(InviteModalError)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ]))
    ]),
    _createVNode(Footer, { ShowMembership: ShowMembership }),
    (!_unref(checkRouteNotAuth))
      ? (_openBlock(), _createBlock(InquiryForm, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(Membership, { data: dataMembership.value }, null, 8, ["data"])
  ], 64))
}
}

})